import React from "react";
import {Card, Space, Typography} from "antd";
import {tokens} from "./tokens";

/** Карточка-секция: заголовок, необязательное описание и действия справа. */
export const SectionCard = ({title, extra, description, children, bodyStyle, ...rest}) => (
    <Card
        bordered={false}
        style={{borderRadius: tokens.radius, boxShadow: tokens.shadow, height: '100%'}}
        bodyStyle={{padding: 16, ...bodyStyle}}
        {...rest}
    >
        {(title || extra) &&
            <div style={{
                display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
                gap: 12, marginBottom: description ? 4 : 12, flexWrap: 'wrap',
            }}>
                <Typography.Title level={5} style={{margin: 0, fontWeight: 600}}>{title}</Typography.Title>
                {extra && <Space size={8} wrap>{extra}</Space>}
            </div>}
        {description &&
            <Typography.Paragraph type={"secondary"} style={{marginBottom: 12, fontSize: 13}}>
                {description}
            </Typography.Paragraph>}
        {children}
    </Card>
)

export default SectionCard
